import { ɵgetAllInstancesOf, ɵgetDefaultInstanceOf, VERSION, ɵAngularFireSchedulers, ɵAppCheckInstances, ɵzoneWrap } from '@angular/fire';
import { from, timer } from 'rxjs';
import { concatMap, distinct } from 'rxjs/operators';
import * as i0 from '@angular/core';
import { InjectionToken, Optional, NgModule, NgZone, Injector } from '@angular/core';
import { FirebaseApp, FirebaseApps } from '@angular/fire/app';
import { AuthInstances } from '@angular/fire/auth';
import { registerVersion } from 'firebase/app';
import { fromRef as fromRef$1, stateChanges as stateChanges$1, list as list$1, listVal as listVal$1, auditTrail as auditTrail$1, object as object$1, objectVal as objectVal$1, changeToData as changeToData$1 } from 'rxfire/database';
export { ListenEvent, ListenerMethods } from 'rxfire/database';
import { child as child$1, connectDatabaseEmulator as connectDatabaseEmulator$1, enableLogging as enableLogging$1, endAt as endAt$1, endBefore as endBefore$1, equalTo as equalTo$1, forceLongPolling as forceLongPolling$1, forceWebSockets as forceWebSockets$1, get as get$1, getDatabase as getDatabase$1, goOffline as goOffline$1, goOnline as goOnline$1, increment as increment$1, limitToFirst as limitToFirst$1, limitToLast as limitToLast$1, off as off$1, onChildAdded as onChildAdded$1, onChildChanged as onChildChanged$1, onChildMoved as onChildMoved$1, onChildRemoved as onChildRemoved$1, onDisconnect as onDisconnect$1, onValue as onValue$1, orderByChild as orderByChild$1, orderByKey as orderByKey$1, orderByPriority as orderByPriority$1, orderByValue as orderByValue$1, push as push$1, query as query$1, ref as ref$1, refFromURL as refFromURL$1, remove as remove$1, runTransaction as runTransaction$1, serverTimestamp as serverTimestamp$1, set as set$1, setPriority as setPriority$1, setWithPriority as setWithPriority$1, startAfter as startAfter$1, startAt as startAt$1, update as update$1 } from 'firebase/database';
export * from 'firebase/database';
class Database {
  constructor(database) {
    return database;
  }
}
const DATABASE_PROVIDER_NAME = 'database';
class DatabaseInstances {
  constructor() {
    return ɵgetAllInstancesOf(DATABASE_PROVIDER_NAME);
  }
}
const databaseInstance$ = /*#__PURE__*/ /*#__PURE__*/timer(0, 300).pipe( /*#__PURE__*/concatMap(() => from(ɵgetAllInstancesOf(DATABASE_PROVIDER_NAME))), /*#__PURE__*/distinct());
const PROVIDED_DATABASE_INSTANCES = /*#__PURE__*/new InjectionToken('angularfire2.database-instances');
function defaultDatabaseInstanceFactory(provided, defaultApp) {
  const defaultDatabase = ɵgetDefaultInstanceOf(DATABASE_PROVIDER_NAME, provided, defaultApp);
  return defaultDatabase && new Database(defaultDatabase);
}
function databaseInstanceFactory(fn) {
  return (zone, injector) => {
    const database = zone.runOutsideAngular(() => fn(injector));
    return new Database(database);
  };
}
const DATABASE_INSTANCES_PROVIDER = {
  provide: DatabaseInstances,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_DATABASE_INSTANCES]]
};
const DEFAULT_DATABASE_INSTANCE_PROVIDER = {
  provide: Database,
  useFactory: defaultDatabaseInstanceFactory,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_DATABASE_INSTANCES], FirebaseApp]
};
let DatabaseModule = /*#__PURE__*/(() => {
  class DatabaseModule {
    constructor() {
      registerVersion('angularfire', VERSION.full, 'rtdb');
    }
    static ɵfac = function DatabaseModule_Factory(t) {
      return new (t || DatabaseModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DatabaseModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [DEFAULT_DATABASE_INSTANCE_PROVIDER, DATABASE_INSTANCES_PROVIDER]
    });
  }
  return DatabaseModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideDatabase(fn, ...deps) {
  return {
    ngModule: DatabaseModule,
    providers: [{
      provide: PROVIDED_DATABASE_INSTANCES,
      useFactory: databaseInstanceFactory(fn),
      multi: true,
      deps: [NgZone, Injector, ɵAngularFireSchedulers, FirebaseApps,
      // Database+Auth work better if Auth is loaded first
      [new Optional(), AuthInstances], [new Optional(), ɵAppCheckInstances], ...deps]
    }]
  };
}

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const fromRef = /*#__PURE__*/ɵzoneWrap(fromRef$1, true);
const stateChanges = /*#__PURE__*/ɵzoneWrap(stateChanges$1, true);
const list = /*#__PURE__*/ɵzoneWrap(list$1, true);
const listVal = /*#__PURE__*/ɵzoneWrap(listVal$1, true);
const auditTrail = /*#__PURE__*/ɵzoneWrap(auditTrail$1, true);
const object = /*#__PURE__*/ɵzoneWrap(object$1, true);
const objectVal = /*#__PURE__*/ɵzoneWrap(objectVal$1, true);
const changeToData = /*#__PURE__*/ɵzoneWrap(changeToData$1, true);

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const child = /*#__PURE__*/ɵzoneWrap(child$1, true);
const connectDatabaseEmulator = /*#__PURE__*/ɵzoneWrap(connectDatabaseEmulator$1, true);
const enableLogging = /*#__PURE__*/ɵzoneWrap(enableLogging$1, true);
const endAt = /*#__PURE__*/ɵzoneWrap(endAt$1, true);
const endBefore = /*#__PURE__*/ɵzoneWrap(endBefore$1, true);
const equalTo = /*#__PURE__*/ɵzoneWrap(equalTo$1, true);
const forceLongPolling = /*#__PURE__*/ɵzoneWrap(forceLongPolling$1, true);
const forceWebSockets = /*#__PURE__*/ɵzoneWrap(forceWebSockets$1, true);
const get = /*#__PURE__*/ɵzoneWrap(get$1, true);
const getDatabase = /*#__PURE__*/ɵzoneWrap(getDatabase$1, true);
const goOffline = /*#__PURE__*/ɵzoneWrap(goOffline$1, true);
const goOnline = /*#__PURE__*/ɵzoneWrap(goOnline$1, true);
const increment = /*#__PURE__*/ɵzoneWrap(increment$1, true);
const limitToFirst = /*#__PURE__*/ɵzoneWrap(limitToFirst$1, true);
const limitToLast = /*#__PURE__*/ɵzoneWrap(limitToLast$1, true);
const off = /*#__PURE__*/ɵzoneWrap(off$1, true);
const onChildAdded = /*#__PURE__*/ɵzoneWrap(onChildAdded$1, true);
const onChildChanged = /*#__PURE__*/ɵzoneWrap(onChildChanged$1, true);
const onChildMoved = /*#__PURE__*/ɵzoneWrap(onChildMoved$1, true);
const onChildRemoved = /*#__PURE__*/ɵzoneWrap(onChildRemoved$1, true);
const onDisconnect = /*#__PURE__*/ɵzoneWrap(onDisconnect$1, true);
const onValue = /*#__PURE__*/ɵzoneWrap(onValue$1, true);
const orderByChild = /*#__PURE__*/ɵzoneWrap(orderByChild$1, true);
const orderByKey = /*#__PURE__*/ɵzoneWrap(orderByKey$1, true);
const orderByPriority = /*#__PURE__*/ɵzoneWrap(orderByPriority$1, true);
const orderByValue = /*#__PURE__*/ɵzoneWrap(orderByValue$1, true);
const push = /*#__PURE__*/ɵzoneWrap(push$1, true);
const query = /*#__PURE__*/ɵzoneWrap(query$1, true);
const ref = /*#__PURE__*/ɵzoneWrap(ref$1, true);
const refFromURL = /*#__PURE__*/ɵzoneWrap(refFromURL$1, true);
const remove = /*#__PURE__*/ɵzoneWrap(remove$1, true);
const runTransaction = /*#__PURE__*/ɵzoneWrap(runTransaction$1, true);
const serverTimestamp = /*#__PURE__*/ɵzoneWrap(serverTimestamp$1, true);
const set = /*#__PURE__*/ɵzoneWrap(set$1, true);
const setPriority = /*#__PURE__*/ɵzoneWrap(setPriority$1, true);
const setWithPriority = /*#__PURE__*/ɵzoneWrap(setWithPriority$1, true);
const startAfter = /*#__PURE__*/ɵzoneWrap(startAfter$1, true);
const startAt = /*#__PURE__*/ɵzoneWrap(startAt$1, true);
const update = /*#__PURE__*/ɵzoneWrap(update$1, true);

/**
 * Generated bundle index. Do not edit.
 */

export { Database, DatabaseInstances, DatabaseModule, auditTrail, changeToData, child, connectDatabaseEmulator, databaseInstance$, enableLogging, endAt, endBefore, equalTo, forceLongPolling, forceWebSockets, fromRef, get, getDatabase, goOffline, goOnline, increment, limitToFirst, limitToLast, list, listVal, object, objectVal, off, onChildAdded, onChildChanged, onChildMoved, onChildRemoved, onDisconnect, onValue, orderByChild, orderByKey, orderByPriority, orderByValue, provideDatabase, push, query, ref, refFromURL, remove, runTransaction, serverTimestamp, set, setPriority, setWithPriority, startAfter, startAt, stateChanges, update };
